export const IDEA_ACTION_EVENT = 'brainstormy-idea-action';

/** Ask the open Idea chat to run one existing action. */
export function publishIdeaAction(action) {
  window.dispatchEvent(new CustomEvent(IDEA_ACTION_EVENT, { detail: action }));
}
